import { NativeAudio } from "./plugins";
import { throwErrorWithStack } from "./crashlytics";
import { menuMusicBtnEl } from "./elements";
import { handlePromises } from "./promise";
import { addTouchEvent } from "./events";
import { IS_SAFARI, IS_WEB } from "./config";
import { getLogger } from "./logging";

const log = getLogger("🔈 Sound");

const VOLUME = 1 / 0.2;
let didInit = false;

async function savePreload(assetId, assetPath, volume, isUrl = false) {
  try {
    await NativeAudio.preload({
      assetId,
      assetPath,
      isUrl,
      audioChannelNum: 1,
      volume: Math.min(1, volume),
    });
  } catch (error) {
    if (error.message === "Audio Asset already exists") return;
    log.error(`Error with '${assetId}' in 'savePreload'`);
    throw error;
  }
}

export async function initSound() {
  if (didInit) return log.warn("🔈 Sounds did already init");
  try {
    await handlePromises([
      savePreload(
        "fast-chop",
        "audio/fast-simple-chop-5-6270.mp3",
        0.13 * VOLUME
      ),
      savePreload("swoosh", "audio/swoosh01-97853.mp3", 0.3 * VOLUME),
      savePreload("collect", "audio/collect-5930.mp3", 0.02 * VOLUME),
      savePreload(
        "harp",
        "audio/harp-glissando-ascending-short-103885.mp3",
        0.05 * VOLUME
      ),
      savePreload("shuffle", "audio/shuffle-cards-46455.mp3", 0.01 * VOLUME),
      savePreload("type", "audio/typewriter.mp3", 0.01 * VOLUME),
      savePreload("click", "audio/click.mp3", 0.01 * VOLUME),
      savePreload(
        "teleport",
        "audio/transition-futuristic-teleport-121420.mp3",
        0.03 * VOLUME
      ),
      savePreload("catch", "audio/click_effect-86995.mp3", 0.02 * VOLUME),
      savePreload("meow", "audio/shari_meow-47485.mp3", 0.1 * VOLUME),
      savePreload("success", "audio/success-48018.mp3", 0.03 * VOLUME),
      //   savePreload("tada", "audio/tada.mp3", 0.1 * VOLUME),
      savePreload("purr", "audio/purr.mp3", 0.1 * VOLUME),
      savePreload("meow2", "audio/meow.mp3", 0.08 * VOLUME),
      _loadAndPlayBackground(),
    ]);
    didInit = true;
  } catch (error) {
    throwErrorWithStack(error);
  }
}

// const BACKGROUND_MUSIC_URI =
//   "https://orestisz-public.s3.amazonaws.com/mix-4m23s.mp3";

async function _loadAndPlayBackground() {
  await savePreload("background", "audio/mix-4m23s.mp3", 0.015 * VOLUME);
  activeMenuOption();
  //   else {
  //     const uri = await _getUri();
  //     if (!uri) {
  //       log.warn("Failed determining URI");
  //       return;
  //     }
  //     const exists = await _exists();
  //     if (!exists) await _download();
  //     await savePreload("background", uri, 0.01 * VOLUME, true);
  //     activeMenuOption();
  //   }
  //   if (!store.disableMusic) loopMp3("background");
}

function activeMenuOption() {
  menuMusicBtnEl.style.display = "block";
}

export async function playMp3(assetId, extras = {}) {
  try {
    await NativeAudio.play({
      assetId,
      ...extras,
    });
  } catch (error) {
    log.error(`Error with '${assetId}' in 'playMp3'`);
    if (
      error.message.startsWith(
        "The play() request was interrupted by a call to pause()"
      )
    ) {
      log.warn(`Ignoring error ${error.message}`);
      return;
    }
    throwErrorWithStack(error);
  }
}

export async function loopMp3(assetId, throwError = false, extras = {}) {
  try {
    await NativeAudio.loop({
      assetId,
      ...extras,
    });
  } catch (error) {
    log.error(`Error with '${assetId}' in 'loopMp3'`);
    const skip = error.message === "Error with asset";
    if (skip || !throwError) log.error(error.message);
    else throwErrorWithStack(error, true);
  }
}

export async function stopMp3(assetId, throwError = false, extras = {}) {
  try {
    await NativeAudio.stop({
      assetId,
      ...extras,
    });
  } catch (error) {
    log.error(`Error with '${assetId}' in 'stopMp3'`);
    if (throwError) throwErrorWithStack(error, true);
    else log.error(error.message);
  }
}

// async function _getUri() {
//   let uri;
//   try {
//     const ret = await Filesystem.getUri({
//       path: "background.mp3",
//       directory: "EXTERNAL",
//     });
//     uri = ret.uri;
//   } catch (error) {
//     log.error("Failed getting URI");
//     throw error;
//   }
//   return uri;
// }

// async function _exists() {
//   try {
//     const { size } = await Filesystem.stat({
//       path: "background.mp3",
//       directory: Directory.External,
//     });
//     if (size) {
//       log.debug("Found existing background music file");
//       return true;
//     }
//   } catch (error) {
//     log.error("Failed checking if file exists");
//   }
//   return false;
// }

// async function _download() {
//   try {
//     log.debug(
//       `Downloading background music file from ${BACKGROUND_MUSIC_URI}...`
//     );
//     const { path } = await FileDownload.download({
//       url: BACKGROUND_MUSIC_URI,
//       fileName: "background.mp3",
//     });
//     log.debug(`Downloaded background music file to ${path}`);
//   } catch (error) {
//     log.error("Failed downloading background music file");
//     throw error;
//   }
// }

function clickSound() {
  playMp3("click");
}

export const addClickToBtn = (element) => {
  if (IS_WEB && IS_SAFARI) return;
  addTouchEvent(element, clickSound, true, "click-listener");
};

export const addClickToBtns = () => {
  Array.prototype.forEach.call(
    document.querySelectorAll(".ripple"),
    addClickToBtn
  );
};
